/**
 * Validates Canva embed code
 * @param {string} embedCode - The embed code to validate
 * @returns {object} { isValid: boolean, error: string | null }
 */
export const validateCanvaEmbedCode = (embedCode) => {
  if (!embedCode || typeof embedCode !== 'string') {
    return { isValid: false, error: 'Embed code is required' };
  }

  const trimmed = embedCode.trim();

  // Check if contains iframe tag (Canva embed is always iframe)
  if (!/<iframe/i.test(trimmed)) {
    return { isValid: false, error: 'Embed code must contain an iframe tag' };
  }

  // Check for closing iframe tag
  if (!/<\/iframe>/i.test(trimmed)) {
    return { isValid: false, error: 'Embed code must have closing iframe tag' };
  }

  // Check for src attribute
  if (!/src\s*=\s*["']/i.test(trimmed)) {
    return { isValid: false, error: 'Embed code must have src attribute' };
  }

  return { isValid: true, error: null };
};

/**
 * Validates Canva URL
 * @param {string} url - The URL to validate
 * @returns {object} { isValid: boolean, error: string | null }
 */
export const validateCanvaUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return { isValid: false, error: 'URL is required' };
  }

  const trimmed = url.trim();

  // Basic URL format check
  try {
    new URL(trimmed);
  } catch {
    return { isValid: false, error: 'Invalid URL format' };
  }

  // Check if it's a Canva URL
  if (!/canva\.com/i.test(trimmed) && !/canva\.link/i.test(trimmed)) {
    return { isValid: false, error: 'URL must be from canva.com' };
  }

  return { isValid: true, error: null };
};
